import { type User } from '@auth0/auth0-react';
import { isUsingDarkTheme } from '@strata/react-header';

import { type FmhToken } from 'api/authAPI';
import { PayerRequestWritePermissions } from 'services/constants';

export const initializePendo = (fmhToken: FmhToken, user: User | undefined) => {
    if (user) {
        pendo.initialize({
            apiKey: process.env.REACT_APP_PENDO_API_KEY,
            visitor: {
                id: user.email!,
                role: fmhToken.role_name,
                email: user.email!,
                name: user.name!,
                dark_mode: isUsingDarkTheme(),
                segment_ids: fmhToken.segment_ids,
                restricted_access: fmhToken.restricted_access,
                analytics_access: fmhToken.analytics_access,
                // This permission is added in authorization-api if user has associated pbm_id
                pbm_user: fmhToken.permissions.includes(
                    PayerRequestWritePermissions.WRITE_PAYER_REQUEST_PBM_ONLY,
                ),
            },
            account: { id: fmhToken.npi, org: fmhToken.npi },
        });
    }
};

export const updatePayerPendo = (fmhToken: FmhToken, user: User | undefined) => {
    if (user) {
        pendo.identify({
            visitor: {
                id: user.email!,
                role: fmhToken.role_name,
                email: user.email!,
                name: user.name!,
                dark_mode: isUsingDarkTheme(),
                segment_ids: fmhToken.segment_ids,
                restricted_access: fmhToken.restricted_access,
                analytics_access: fmhToken.analytics_access,
                // This permission is added in authorization-api if user has associated pbm_id
                pbm_user: fmhToken.permissions.includes(
                    PayerRequestWritePermissions.WRITE_PAYER_REQUEST_PBM_ONLY,
                ),
            },
            account: { id: fmhToken.npi, org: fmhToken.npi },
        });
    }
};

export const updatePendoUserMetadata = (payerName: string, segmentNames: string[]) => {
    pendo.updateOptions({ visitor: { segment_names: segmentNames }, account: { name: payerName } });
};
